// @TODO refactor icon to two paths without circle element and themeable fill colors
import React from 'react'
import { SvgIcon } from '../svg-icon'

const defaultProps = {
    width: 32,
    height: 32
}

/**
 * Renders a validation success icon
 * @see SvgIcon for propTypes
 *
 * @example
 * <ValidationSuccessIcon width={12} />
 */
const ValidationSuccessIcon = props => (
    <SvgIcon viewBox="0 0 112 112" {...props}>
        <g>
            <path
                style={{ fill: '#7BAA21' }}
                d={`M56,5c28.1,0,51,22.9,51,51s-22.9,51-51,51S5,84.1,5,56S27.9,5,56,5
                M56,0C25.1,0,0,25.1,0,56s25.1,56,56,56 s56-25.1,56-56S86.9,0,56,0L56,0z`}
            />
        </g>
        <g>
            <circle style={{ fill: '#7BAA21' }} cx="56" cy="56" r="46" />
        </g>
        <g>
            <path
                style={{ fill: '#FFFFFF' }}
                d={`M45.4,76.9L28.8,60.2c-1.1-1.1-1.1-3.1,0-4.2l4.2-4.2c1.1-1.1,3.1-1.1,4.2,0l16.7,
                16.7c1.1,1.1,1.1,3.1,0,4.2 l-4.2,4.2C48.6,78,46.6,78,45.4,76.9z`}
            />
            <path
                style={{ fill: '#FFFFFF' }}
                d="M83.2,43.4L49.7,76.9c-1.1,1.1-3.1,1.1-4.2,0l-4.2-4.2c-1.1-1.1-1.1-3.1,0-4.2l33.5-33.3
            c1.1-1.1,3.1-1.1,4.2,0l4.2,4.2C84.3,40.5,84.3,42.3,83.2,43.4z"
            />
        </g>
    </SvgIcon>
)

ValidationSuccessIcon.defaultProps = defaultProps

export { ValidationSuccessIcon }
